<template>
  <v-tabs>
    <v-tab
        v-if="routeRequirementsGeneral"
        :to="{
        name: 'PatientOverviewHNProgressGeneral',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("general")) }}
    </v-tab>
    <v-tab
        v-if="routeRequirementsWeeklyGoals"
        :to="{
        name: 'PatientOverviewHNProgressWeeklyGoals',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("nutrition.tabs.weeklyGoals")) }}
    </v-tab>
    <v-tab
        v-if="routeRequirementsOverTime"
        :to="{
        name: 'PatientOverviewHNProgressOverTime',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("nutrition.tabs.progressOverTime")) }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapGetters } from "vuex";
import { routeRequirements as routeRequirementsGeneral } from "../../../../router/routes/home/patient/record/healthy-nutrition/progress/general";
import { routeRequirements as routeRequirementsWeeklyGoals } from "../../../../router/routes/home/patient/record/healthy-nutrition/progress/weekly-goals";
import { routeRequirements as routeRequirementsOverTime } from "../../../../router/routes/home/patient/record/healthy-nutrition/progress/over-time";
import {mapRouteRequirements} from "../../../../app";

/**
 * Component JourneyProgressTabs.vue
 *
 * @module JourneyProgressTabs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/JourneyProgressTabs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverHNProgressTabs",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
    ...mapRouteRequirements({
      routeRequirementsGeneral,
      routeRequirementsWeeklyGoals,
      routeRequirementsOverTime
    })
  },
};
</script>

<style lang="scss">
</style>
